/* Mowrator page kit: reveals, counters, slope meter, story tabs, panels, board, before/after, kit, filmstrip, video, sticky bar.
   No dependencies. Respects prefers-reduced-motion. Safe to load more than once. */
(function () {
  if (window.__mwKit) return;
  window.__mwKit = true;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var phone = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var f = (window.Shopify && Shopify.formatMoney) ? null : null;
    return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* Split headings into masked words */
  function splitWords(el) {
    if (el.dataset.mwSplit) return;
    el.dataset.mwSplit = "1";
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement("span"); w.className = "mw-w";
            var inner = document.createElement("span"); inner.textContent = p; inner.style.setProperty("--i", i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains("mw-w")) walk(n);
      });
    })(el);
  }

  /* Rolling counters: "0.5", "1,985", "931" */
  function buildRoll(el) {
    if (el.dataset.mwBuilt) return;
    el.dataset.mwBuilt = "1";
    var target = el.getAttribute("data-mw-count");
    el.textContent = "";
    el.classList.add("mw-roll");
    el.setAttribute("aria-label", target);
    var d = 0;
    target.split("").forEach(function (ch) {
      if (/\d/.test(ch)) {
        var col = document.createElement("span"); col.className = "mw-roll__col"; col.setAttribute("aria-hidden", "true");
        col.style.setProperty("--d", d++);
        for (var k = 0; k <= 9; k++) { var s = document.createElement("span"); s.textContent = k; col.appendChild(s); }
        col.dataset.to = ch; el.appendChild(col);
      } else {
        var st = document.createElement("span"); st.className = "mw-roll__static"; st.setAttribute("aria-hidden", "true"); st.textContent = ch; el.appendChild(st);
      }
    });
  }
  function runRoll(el) { $$(".mw-roll__col", el).forEach(function (c) { c.style.transform = "translateY(" + (-parseInt(c.dataset.to, 10)) + "em)"; }); }

  /* Reveal on view */
  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add("is-in");
      if (el.hasAttribute("data-mw-count")) runRoll(el);
      io.unobserve(el);
    });
  }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 }) : null;

  function initReveals(root) {
    $$("[data-mw-words]", root).forEach(splitWords);
    $$("[data-mw-count]", root).forEach(buildRoll);
    $$("[data-mw-lift]", root).forEach(function (el) {
      var sibs = el.parentNode ? $$(":scope > [data-mw-lift]", el.parentNode) : [];
      if (!el.style.getPropertyValue("--i")) el.style.setProperty("--i", Math.max(0, sibs.indexOf(el)));
    });
    var els = $$("[data-mw-words],[data-mw-wipe],[data-mw-lift],[data-mw-count],.mw-board", root);
    els.forEach(function (el) {
      if (reduce || !io) { el.classList.add("is-in"); if (el.hasAttribute("data-mw-count")) runRoll(el); }
      else io.observe(el);
    });
  }

  /* Autoplay muted loops only while visible */
  function initVideos(root) {
    var vids = $$("video[data-mw-auto]", root);
    if (reduce || phone) { vids.forEach(function (v) { v.removeAttribute("autoplay"); v.pause && v.pause(); }); return; } /* phones: poster only (2026-09-28) */
    if (!("IntersectionObserver" in window)) return;
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.preload === "none") v.preload = "auto"; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; vo.observe(v); });
  }

  /* Slope meter */
  function initSlope(root) {
    $$("[data-mw-slope]", root).forEach(function (box) {
      var stage = $(".mw-slope__stage", box), deg = $("[data-mw-deg]", box), grade = $("[data-mw-grade]", box), name = $("[data-mw-edname]", box);
      var picks = $$(".mw-pick", box);
      function pick(btn, instant) {
        picks.forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
        var d = parseFloat(btn.dataset.deg);
        stage.style.setProperty("--deg", d);
        if (!instant && !reduce) { stage.classList.add("is-moving"); clearTimeout(stage._mwT); stage._mwT = setTimeout(function () { stage.classList.remove("is-moving"); }, 1300); }
        stage.style.setProperty("--arc", (Math.PI * 2 * 100 * (d / 360)).toFixed(1));
        if (grade) grade.textContent = btn.dataset.grade + " grade";
        if (name) name.textContent = btn.dataset.name;
        if (!deg) return;
        if (instant || reduce) { deg.textContent = d; return; }
        var from = parseFloat(deg.textContent) || 0, t0 = performance.now();
        (function tick(t) { var k = Math.min(1, (t - t0) / 900); var e = 1 - Math.pow(1 - k, 3); deg.textContent = Math.round(from + (d - from) * e); if (k < 1) requestAnimationFrame(tick); })(t0);
      }
      picks.forEach(function (b) { b.addEventListener("click", function () { pick(b); }); });
      var here = picks.filter(function (b) { return b.dataset.here === "1"; })[0] || picks[picks.length - 1];
      if (here) {
        pick(picks[0], true);
        if ("IntersectionObserver" in window && !reduce) {
          var so = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { setTimeout(function () { pick(here); }, 300); so.disconnect(); } }, { threshold: 0.4 });
          so.observe(stage);
        } else pick(here, true);
      }
    });
  }

  /* Segmented tabs */
  function initTabs(root) {
    $$("[data-mw-tabs]", root).forEach(function (box) {
      var tabs = $$("[role=tab]", box), panels = $$("[role=tabpanel]", box);
      function show(i) {
        tabs.forEach(function (t, k) { t.setAttribute("aria-selected", k === i ? "true" : "false"); t.tabIndex = k === i ? 0 : -1; });
        panels.forEach(function (p, k) { p.hidden = k !== i; p.classList.toggle("is-on", k === i); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { show(i); });
        t.addEventListener("keydown", function (e) {
          if (e.key === "ArrowRight" || e.key === "ArrowLeft") { var n = (i + (e.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length; show(n); tabs[n].focus(); }
        });
      });
      show(0);
    });
  }

  /* Expanding panels */
  function initPanels(root) {
    $$("[data-mw-panels]", root).forEach(function (box) {
      var ps = $$(".mw-panel", box);
      function open(p) {
        ps.forEach(function (q) {
          var on = q === p; q.classList.toggle("is-open", on); q.setAttribute("aria-expanded", on ? "true" : "false");
          var v = $("video", q); if (v) { if (on && !reduce && !phone) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
        });
      }
      ps.forEach(function (p) {
        p.addEventListener("click", function () { open(p); });
        p.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(p); } });
        if (window.matchMedia("(hover: hover)").matches) p.addEventListener("mouseenter", function () { open(p); });
      });
      open(ps[0]);
    });
  }

  /* Editions board: differences only */
  function initBoard(root) {
    $$(".mw-board", root).forEach(function (b) {
      var t = $("[data-mw-diff]", b);
      if (t) t.addEventListener("change", function () { b.classList.toggle("is-diff", t.checked); });
    });
  }

  /* Before / after */
  function initBA(root) {
    $$("[data-mw-ba]", root).forEach(function (b) {
      var r = $("input", b);
      var host = b.closest(".mw") || b; /* --p (0 to 100) also drives the tag fade and column highlight, 2026-09-29 */
      var set = function () { b.style.setProperty("--pos", r.value + "%"); host.style.setProperty("--p", r.value); };
      r.addEventListener("input", set); set();
      if (!reduce && "IntersectionObserver" in window) {
        var o = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return; o.disconnect();
          var t0 = performance.now();
          (function tick(t) { var k = Math.min(1, (t - t0) / 1600); var v = 50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k); r.value = v; set(); if (k < 1) requestAnimationFrame(tick); })(t0);
        }, { threshold: 0.5 });
        o.observe(b);
      }
    });
  }

  /* Kit builder: add selected accessories to cart */
  function initKit(root) {
    $$("[data-mw-kit]", root).forEach(function (box) {
      var boxes = $$("input[type=checkbox]", box), lines = $(".mw-kit__lines", box), total = $("[data-mw-total]", box), btn = $("[data-mw-add]", box), msg = $(".mw-kit__msg", box);
      function sync() {
        var sum = 0; lines.innerHTML = "";
        boxes.forEach(function (c) {
          if (!c.checked) return;
          sum += parseInt(c.dataset.price, 10);
          var li = document.createElement("li"); li.innerHTML = "<span></span><span></span>";
          li.firstChild.textContent = c.dataset.title; li.lastChild.textContent = money(parseInt(c.dataset.price, 10));
          lines.appendChild(li);
        });
        if (!lines.children.length) { var e = document.createElement("li"); e.textContent = lines.dataset.empty || "Pick the parts you want."; lines.appendChild(e); }
        total.textContent = money(sum);
        btn.disabled = sum === 0;
      }
      boxes.forEach(function (c) { c.addEventListener("change", sync); });
      btn.addEventListener("click", function () {
        var items = boxes.filter(function (c) { return c.checked; }).map(function (c) { return { id: parseInt(c.value, 10), quantity: 1 }; });
        if (!items.length) return;
        btn.disabled = true; msg.textContent = "Adding to your cart...";
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { msg.textContent = "Added. Taking you to your cart."; window.location.href = root + "cart"; })
          .catch(function (err) { msg.textContent = (err && (err.description || err.message)) || "Could not add these items. Please call +1 423-927-3776."; btn.disabled = false; });
      });
      sync();
    });
  }

  /* Filmstrip: drag, arrows, progress */
  function initStrips(root) {
    $$("[data-mw-strip]", root).forEach(function (s) {
      var tr = $(".mw-strip__track", s), bar = $(".mw-strip__bar", s), prev = $("[data-mw-prev]", s), next = $("[data-mw-next]", s);
      function prog() { var max = tr.scrollWidth - tr.clientWidth; var p = max > 0 ? (tr.clientWidth / tr.scrollWidth) * 100 + (tr.scrollLeft / max) * (100 - (tr.clientWidth / tr.scrollWidth) * 100) : 100; if (bar) bar.style.setProperty("--p", p + "%"); }
      tr.addEventListener("scroll", prog, { passive: true }); prog();
      var step = function (dir) { tr.scrollBy({ left: dir * tr.clientWidth * 0.8, behavior: reduce ? "auto" : "smooth" }); };
      if (prev) prev.addEventListener("click", function () { step(-1); });
      if (next) next.addEventListener("click", function () { step(1); });
      var down = false, x0 = 0, s0 = 0, vx = 0, lx = 0, lt = 0, moved = false;
      tr.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse") return; down = true; moved = false; x0 = lx = e.clientX; s0 = tr.scrollLeft; lt = performance.now(); tr.classList.add("is-drag"); });
      window.addEventListener("pointermove", function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) moved = true; tr.scrollLeft = s0 - dx; var t = performance.now(); vx = (e.clientX - lx) / Math.max(1, t - lt); lx = e.clientX; lt = t; });
      window.addEventListener("pointerup", function () {
        if (!down) return; down = false; tr.classList.remove("is-drag");
        if (reduce) return;
        var v = vx * 16;
        (function glide() { if (Math.abs(v) < 0.5) return; tr.scrollLeft -= v; v *= 0.94; requestAnimationFrame(glide); })();
      });
      tr.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* YouTube: load the player only when asked */
  function initTubes(root) {
    $$("[data-mw-yt]", root).forEach(function (b) {
      b.addEventListener("click", function () {
        var id = b.getAttribute("data-mw-yt");
        var f = document.createElement("iframe");
        f.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0";
        f.title = b.getAttribute("aria-label") || "Video";
        f.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        f.allowFullscreen = true;
        b.replaceWith(f);
      });
    });
  }

  /* Accessory fit checker */
  function initFit(root) {
    $$("[data-mw-fit]", root).forEach(function (box) {
      var btns = $$(".mw-fit__btn", box), out = $(".mw-fit__out", box), icon = $(".mw-fit__icon", box), txt = $(".mw-fit__txt", box);
      btns.forEach(function (b) {
        b.addEventListener("click", function () {
          btns.forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
          var yes = b.dataset.fits === "1";
          out.classList.remove("is-yes", "is-no", "is-pop"); void out.offsetWidth;
          out.classList.add(yes ? "is-yes" : "is-no", "is-pop");
          icon.textContent = yes ? "✓" : "✕";
          txt.textContent = yes ? b.dataset.yes : b.dataset.no;
        });
      });
    });
  }

  /* Scrolly steps: swap the pinned image */
  function initSteps(root) {
    $$("[data-mw-steps]", root).forEach(function (box) {
      var steps = $$(".mw-step", box), imgs = $$(".mw-steps__pin img", box);
      if (!("IntersectionObserver" in window)) { steps.forEach(function (s) { s.classList.add("is-on"); }); return; }
      var so = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = steps.indexOf(e.target);
          steps.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
          imgs.forEach(function (im, k) { im.classList.toggle("is-on", k === (i % imgs.length)); });
        });
      }, { rootMargin: "-45% 0px -45% 0px" });
      steps.forEach(function (s) { so.observe(s); });
      if (steps[0]) steps[0].classList.add("is-on");
      if (imgs[0]) imgs[0].classList.add("is-on");
    });
  }

  /* Polaroid drift on scroll */
  function initDrift(root) {
    var snaps = $$("[data-mw-drift]", root);
    if (!snaps.length || reduce || window.matchMedia("(max-width: 989px), (hover: none)").matches) return;
    var ticking = false;
    function upd() {
      ticking = false;
      snaps.forEach(function (s) {
        var r = s.getBoundingClientRect(); var c = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        s.style.setProperty("--drift", (c * parseFloat(s.dataset.mwDrift || 30) * (innerWidth < 600 ? 0.35 : 1)).toFixed(1) + "px");
      });
    }
    addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* Sticky add-to-cart */
  function initSticky() {
    var bar = $("[data-mw-sticky]");
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var anchor = form || $(".product-title") || document.body;
    var go = $("[data-mw-sticky-go]", bar);
    if (go) go.addEventListener("click", function () {
      if (form) { var b = form.querySelector('[type=submit],[name=add]'); if (b && !b.disabled) { b.click(); return; } }
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
    if (!("IntersectionObserver" in window)) return;
    var o = new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle("is-on", past);
    });
    o.observe(anchor);
  }


  /* Lineup showcase: highlight the chapter in view */
  function initShow(root) {
    $$("[data-mw-show]", root).forEach(function (box) {
      var tabs = $$("[data-mw-tab]", box), chs = $$("[data-mw-chapter]", box);
      if (!("IntersectionObserver" in window)) return;
      var o = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          tabs.forEach(function (t) {
            var on = t.dataset.mwTab === e.target.id;
            t.classList.toggle("is-on", on);
            var bar = t.parentNode;
            if (on && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: t.offsetLeft - 24, behavior: reduce ? "auto" : "smooth" });
          });
        });
      }, { rootMargin: "-40% 0px -55% 0px" });
      chs.forEach(function (c) { o.observe(c); });
    });
  }

  /* Find your S1: rules follow Mowrator's slope ratings; the Snow Plow Kit needs a 4WD edition */
  function initFinder(root) {
    $$("[data-mw-finder]", root).forEach(function (box) {
      var qs = $$(".mw-q", box), idle = $(".mw-find__idle", box), prog = $(".mw-find__prog", box), res = $$(".mw-find__res", box);
      function val(q) { var c = $("input:checked", q); return c ? c.value : null; }
      function run() {
        var a = {}, done = 0;
        qs.forEach(function (q) { var v = val(q); q.classList.toggle("is-done", !!v); if (v) { a[q.dataset.q] = v; done++; } });
        if (prog) prog.style.setProperty("--p", (done / qs.length * 100) + "%");
        if (done < qs.length) { idle.hidden = false; res.forEach(function (r) { r.hidden = true; }); return; }
        var slope = parseInt(a.slope, 10), why = [];
        var key = slope <= 24 ? "m2" : slope <= 37 ? "m4" : slope <= 40 ? "ww" : "gt";
        if (slope <= 24) why.push("Your slopes sit within the 2WD's 24° (45% grade) rating.");
        else if (slope <= 37) why.push("The 4WD is rated for 37° (75% grade), enough for your hills.");
        else if (slope <= 40) why.push("You need 40° (85% grade), the Wide Wheel Edition's rating.");
        else why.push("Only the Grip Tread Edition is rated for 50° (119% grade).");
        if (a.snow === "yes" && key === "m2") { key = "m4"; why.push("The Snow Plow Kit fits the 4WD editions only, so we moved you up to the 4WD."); }
        else if (a.snow === "yes") why.push("Your match takes the Snow Plow Kit (4WD editions only).");
        if (a.ground === "soft" && key === "m4") { key = "ww"; why.push("On soft or wet ground the wide wheels spread the weight for more grip and less turf damage."); }
        else if (a.ground === "soft") why.push("On soft turf, mow when the grass is dry and avoid tight turns on slopes.");
        if (a.ground === "rough" && key !== "m2") why.push("Every 4WD edition clears obstacles up to 3.94 inches: roots, ruts and ditch edges.");
        if (a.ground === "rough" && key === "m2") why.push("The 2WD copes with bumps; a 4WD edition clears 3.94-inch obstacles if you want more margin.");
        var batt = (key === "ww" || key === "gt") ? "Battery: the 18Ah pack comes in the box, up to 2.25 hours and 1.125 acres per charge." :
          a.size === "big" ? "Battery: choose the 18Ah option, up to 2.25 hours and 1.125 acres per charge. A spare pack keeps you going." :
          "Battery: the 12Ah option covers about 0.75 acre and 1.5 hours per charge. Pick 18Ah for extra margin.";
        idle.hidden = true;
        res.forEach(function (r) {
          var on = r.dataset.key === key; r.hidden = !on;
          if (!on) return;
          var ul = $("[data-mw-why]", r); ul.innerHTML = "";
          why.forEach(function (w) { var li = document.createElement("li"); li.textContent = w; ul.appendChild(li); });
          $("[data-mw-batt]", r).textContent = batt;
          r.style.animation = "none"; void r.offsetWidth; r.style.animation = "";
        });
      }
      $$("input", box).forEach(function (i) { i.addEventListener("change", run); });
      run();
    });
  }

  /* How it's built: swap the figure to the part in focus */
  function initBuild(root) {
    $$("[data-mw-build]", root).forEach(function (box) {
      var imgs = $$(".mw-build__slot", box), items = $$(".mw-build__item", box), cap = $("[data-mw-cap]", box);
      var base = cap ? cap.textContent : "";
      function show(it) {
        var i = it ? it.dataset.i : "0";
        imgs.forEach(function (im) { im.classList.toggle("is-on", im.dataset.i === i); var ii = im.querySelector("img"); if (im.dataset.i === i && ii && ii.loading === "lazy") ii.loading = "eager"; });
        items.forEach(function (x) { x.classList.toggle("is-on", x === it); });
        if (cap) cap.textContent = it ? it.dataset.cap : base;
      }
      items.forEach(function (it) {
        it.addEventListener("mouseenter", function () { show(it); });
        it.addEventListener("focus", function () { show(it); });
        it.addEventListener("click", function () { show(it); });
      });
      box.addEventListener("mouseleave", function () { show(null); });
    });
  }

  function init(root) {
    root = root || document;
    initReveals(root); initVideos(root); initSlope(root); initTabs(root); initPanels(root); initBoard(root);
    initBA(root); initKit(root); initStrips(root); initTubes(root); initFit(root); initSteps(root); initDrift(root); initShow(root); initFinder(root); initBuild(root);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); initSticky(); });
  else { init(); initSticky(); }
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
